import { FaGithub, FaLinkedin, FaEnvelope, FaArrowUp, FaMapMarkerAlt, FaBriefcase } from 'react-icons/fa';
import { motion } from 'framer-motion';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: FaGithub,
      href: 'https://github.com/JerwinTitus2006',
      label: 'GitHub',
    },
    {
      icon: FaLinkedin,
      href: 'https://www.linkedin.com',
      label: 'LinkedIn',
    },
    {
      icon: FaEnvelope,
      href: 'mailto:titusjerwin@gmail.com',
      label: 'Email',
    },
  ];

  const quickLinks = [
    { label: 'Home', href: '#home' },
    { label: 'About', href: '#about' },
    { label: 'Skills', href: '#skills' },
    { label: 'Projects', href: '#projects' },
    { label: 'Experience', href: '#experience' },
    { label: 'Achievements', href: '#achievements' },
    { label: 'Contact', href: '#contact' },
  ];

  const renderBrackets = () => (
    <>
      <span className="reticle-bracket top-0 left-0 border-t border-l border-white-pure group-hover:translate-x-0.5 group-hover:translate-y-0.5 group-hover:opacity-100" />
      <span className="reticle-bracket top-0 right-0 border-t border-r border-white-pure group-hover:-translate-x-0.5 group-hover:translate-y-0.5 group-hover:opacity-100" />
      <span className="reticle-bracket bottom-0 left-0 border-b border-l border-white-pure group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:opacity-100" />
      <span className="reticle-bracket bottom-0 right-0 border-b border-r border-white-pure group-hover:-translate-x-0.5 group-hover:-translate-y-0.5 group-hover:opacity-100" />
    </>
  );

  return (
    <footer className="relative bg-void border-t border-grey-800 overflow-hidden">
      {/* Precision CAD gridlines helper in background */}
      <div className="absolute inset-0 z-0 bg-cad-grid opacity-[0.15] pointer-events-none" />

      <div className="container-custom relative z-10 px-4 sm:px-6 lg:px-8 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand Section */}
          <div className="space-y-4">
            <motion.h3
              className="text-lg font-mono tracking-widest font-black flex items-center gap-3"
              whileHover={{ scale: 1.01 }}
            >
              <div className="w-8 h-8 border border-grey-600 bg-void flex items-center justify-center relative">
                <svg className="w-5 h-5" viewBox="0 0 100 100">
                  <rect x="15" y="15" width="70" height="70" fill="none" stroke="#3d3d3d" strokeWidth="1.5" />
                  <path
                    d="M 30,30 L 70,30 M 50,30 L 50,65 C 50,75 35,75 35,65"
                    fill="none"
                    stroke="#ffffff"
                    strokeWidth="6"
                    strokeLinecap="square"
                    strokeLinejoin="miter"
                  />
                </svg>
              </div>
              <span className="text-white-pure uppercase">JERWIN TITUS D</span>
            </motion.h3>
            <p className="text-grey-400 text-xs leading-relaxed font-sans">
              AI & Data Science Engineer specialized in constructing high-performance, deep learning computer vision solutions and MLOps platforms.
            </p>
            <div className="flex gap-2">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.href}
                  target={social.href.startsWith('http') ? '_blank' : '_self'}
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-8 h-8 bg-elevated border border-grey-800 flex items-center justify-center text-grey-400 hover:text-white-pure hover:border-grey-600 transition-colors duration-200 relative group"
                  whileHover={{ y: -1 }}
                  whileTap={{ scale: 0.95 }}
                >
                  {renderBrackets()}
                  <social.icon className="text-xs" />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-mono font-bold uppercase tracking-widest text-white-pure mb-5">SYSTEM // NAVIGATION</h4>
            <ul className="grid grid-cols-2 gap-2 text-xs font-mono">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-grey-400 hover:text-white-pure transition-colors duration-200 inline-block hover:translate-x-1 transform"
                  >
                    // {link.label.toUpperCase()}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xs font-mono font-bold uppercase tracking-widest text-white-pure mb-5">SYSTEM // CREDENTIALS</h4>
            <ul className="space-y-3 text-xs font-mono text-grey-400">
              <li className="flex items-center gap-2.5">
                <FaMapMarkerAlt className="text-grey-600 text-xs" />
                <span>COIMBATORE, INDIA</span>
              </li>
              <li className="flex items-center gap-2.5">
                <FaEnvelope className="text-grey-600 text-xs" />
                <a
                  href="mailto:titusjerwin@gmail.com"
                  className="hover:text-white-pure transition-colors"
                >
                  titusjerwin@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <FaBriefcase className="text-grey-600 text-xs" />
                <span className="text-white-pure font-bold">STATUS // ACTIVE_COOPERATION</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-[1px] bg-grey-800 mb-10" />

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-grey-600 text-[10px] font-mono text-center md:text-left">
            © {currentYear} JERWIN TITUS D. ALL RIGHTS RESERVED. SECURE CONFIGURATION // BUILD_INFO: REACT_VITE_V2.0
          </p>

          <div className="flex items-center gap-6 text-[10px] font-mono text-grey-600">
            <span>SOLI DEO GLORIA // ⚜️</span>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <motion.button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-10 h-10 border border-grey-800 bg-void flex items-center justify-center z-50 group hover:border-white-pure transition-colors duration-200"
        whileHover={{ y: -2 }}
        whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        aria-label="Scroll to top"
      >
        {renderBrackets()}
        <FaArrowUp className="text-grey-400 group-hover:text-white-pure text-xs" />
      </motion.button>
    </footer>
  );
};

export default Footer;
